<template>
    <!-- <div style="height:100%;overflow:hidden">
        <keep-alive :include="keepAlive">
            <router-view v-if="!$route.meta.refresh"></router-view>
        </keep-alive>
        <router-view v-if="$route.meta.refresh"></router-view>
    </div> -->
    <div class="main-box" >
        <keep-alive>
            <router-view :key="key" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view :key="key" v-if="!$route.meta.keepAlive"></router-view>
    </div>

</template>


<script>
export default{
  	computed: {
		key() {
		  console.log('path->'+this.$route.path)
      let endIndex = this.$route.path.lastIndexOf('course-detail')
		  // 用于生成组件的唯一id，使得教学内容页面下的三个子tab页面能归属于同一个父组件下
      if (endIndex > 0) {
		    return this.$route.path.substring(0, endIndex) + 'course-detail'
		  }
		  return this.$route.path
		}
	},
    data(){
        return{
            // keepAlive : 'schedule,courseList,courseDetail'
            keepAlive : [
                'courseList'
                ,'courseDetail'
                ,'msgList'
            ]
        }
    },

}
</script>
<style scoped>
.main-box{height:100%;overflow: hidden;}
</style>



// WEBPACK FOOTER //
// src/frame/frame.vue